export function isStoredStripePaymentReady(setup = {}) {
  return setup?.onboardingCompleted === true
    && setup?.chargesEnabled === true
    && setup?.payoutsEnabled === true
    && setup?.transfersEnabled === true;
}

export function getStoredStripeReadinessState(setup = {}) {
  if (isStoredStripePaymentReady(setup)) return 'ready';
  if (!String(setup?.accountId || '').trim()) return 'not_connected';
  if (setup?.onboardingCompleted !== true) return 'onboarding_incomplete';
  return 'restricted';
}
